/**
 * null => ''
 * @param {*} data 要处理的数据
 */

function nullToStr(data) {
    for (let x in data) {
      if (data[x] === 'null' || data[x] === null) { // 如果是null 把直接内容转为 ''
        data[x] = '';
      } else {
        if (Array.isArray(data[x])) { // 是数组遍历数组 递归继续处理
          data[x] = data[x].map(z => {
            return nullToStr(z);
          });
        }
        if(typeof(data[x]) === 'object'){ // 是json 递归继续处理
          data[x] = nullToStr(data[x])
        }
      }
    }
    return data;
  }

  export default nullToStr
